import moment from 'moment'
import 'moment/locale/es'

moment.locale('es')

const dataBlog = [
    {   
        date: moment("2022-11-28"),
        title: "Mis certificados",
        index: 0,
        urlPage: "mis-certificados",
        main: "misCertificados",
        footer: "asdf"
    },
    {
        date: moment('2022-11-20'),
        title: "Actualizar Linux cambiando los repositorios",
        index: 1,
        urlPage: "actualizar-linux-cambiando-los-repositorios",
        main: "actualizarLinuxCambiandoLosRepositorios",
        footer: "asdf"
    },
    {
        date: moment('2022-11-18'),
        title: "Obtener / Setear scroll en JS - Programación",
        index: 2,
        urlPage: "obtener-setear-scroll-en-js-programacion",
        main: "obtenerSetearScrollEnJsProgramacion",
        footer: "asdf"
    },
    {
        date: moment('2022-11-12'),
        title: "Instalar SDK (sólo) de Android Studio - Linux",
        index: 3,
        urlPage: "instalar-sdk-de-android-studio-linux",
        main: "instalarSdkDeAndroidStudioLinux",
        footer: "asdf"
    },
    {
        date: moment('2022-11-04'),
        title: "initramfs: ¿Heroe o Villano? - Linux",
        index: 4,
        urlPage: "initramfs-unexpected-inconsistency-linux",
        main: "initramfsUnexpectedInconsistencyLinux",
        footer: "adsf"
    },
    {
        date: moment('2022-10-27'),
        title: "Personalización para Sublime Text 3",
        index: 5,
        urlPage: "personalizacion-para-sublime-text-3",
        main: "personalizacionParaSublimeText3",
        footer: "adsf"

    },
    {
        date: moment('2022-10-22'),
        title: "Notas: librerias de ReactJS",
        index: 6,
        urlPage: "notas-librerias-de-reactjs",
        main: "notasLibreriasDeReactjs",
        footer: "asdf"
    },
    {
        date: moment('2022-08-16'),
        title: "Problemas frecuentes con Git",
        index: 7,
        urlPage: "problemas-frecuentes-con-git",
        main: "problemasFrecuentesConGit",
        footer: "asdf"
    },
    {
        date: moment('2022-08-12'),
        title: "Deshabilitar atualizaciones automáticas - Windows 10",
        index: 8,
        urlPage: "deshabilitar-actualizaciones-automaticas-windows-10",
        main: "deshabilitarActualizacionesAutomaticasWindows10",
        footer: "asdf"
    },
    {
        date: moment('2022-08-11'),
        title: "Pantalla negra en OBS - Windows 10",
        index: 9,
        urlPage: "pantalla-negra-en-obs-windows-10",
        main: "pantallaNegraEnObsStudioWindows10",
        footer: "asdf"
    },
    {
        date: moment('2022-08-08'),
        title: "Instalar Mongodb en Kubuntu Jammy - Problemas - Linux",
        index: 10,
        urlPage: "instalar-mongodb-org-en-kubuntu-jammy-problemas-linux",
        main: "instalarMongoDbEnKubuntuJammyProblemasLinux",
        footer: "asdf"
    },
    {
        date: moment('2022-08-08'),
        title: "Solución: loadlibrary failed 1114 - Windows 10",
        index: 11,
        urlPage: "solucion-loadlibrary-failed-1114-windows-10",
        main: "solucionLoadlibraryFailed1114Windows10",
        footer: "asdf"
    },
    {
        date: moment('2022-08-06'),
        title: "Instalar idiomas - Windows 7",
        index: 12,
        urlPage: "instalar-idiomas-windows-7",
        main: "instalarIdiomasWindows7",
        footer: "asdf"
    },
    {
        date: moment('2022-08-06'),
        title: 'Configuración básica - Git (Fork)',
        index: 13,
        urlPage: 'configuracion-basica-git-fork',
        main: "configuracionBasicaGitFork",
        footer: "asdf"
    },
    {
        date: moment("2022-08-04"),
        title: "Configuración de repositorios - Linux",
        index: 14,
        urlPage: "configuracion-de-repositorios-linux",
        main: "configuracionDeRepositoriosLinux",
        footer: "asdf"
    },
    {
        date: moment('2022-07-31'),
        title: 'Solución: actualizaciones con error 80072EFE - Windows 7',
        index: 15,
        urlPage: 'solucion-actualizaciones-con-error-80072efe-windows-7',
        main: 'solucionActualizacionesConError80072efeWindows7',
        footer: 'asdf'
    },
    {
        date: moment('2022-07-29'),
        title: 'Lista de repositorios - Linux',
        index: 16,
        urlPage: "lista-de-repositorios",
        main: "listaDeRepositoriosLinux",
        footer: "asdf"
    },
    {
        date: moment('2022-07-29'),
        title: 'Problemas con repositorios y clave pública - Linux',
        index: 17,
        urlPage: 'problemas-con-repositorios-y-clave-publica-linux',
        main: "problemasConRepositoriosYClavePublicaLinux",
        footer: "asdf"
    },
    {
        date: moment('2022-07-24'),
        title: 'Solución: No booteable device / grub rescue',
        index: 18,
        urlPage: 'solucion-no-booteable-device-grub-rescue',
        main: "solucionNoBooteableDeviceGrubRescue",
        footer: "asdf"
    }

    // {
    //     title: "Diagrama Treemap con D3",
    //     image: "imgTreemapDiagram",
    //     index: 1,
    //     newProject: false,
    //     urlPage:"diagrama-treemap-d3js",
    //     urlGit: "https://github.com/garciapereirajuan/treemap-diagram-d3js",
    //     element: "AppTreemapDiagram"
    // },
    // {
    //     title:"Gráfico de dispersión con D3", 
    //     image: "imgScatterplotGraph", 
    //     index: 2, 
    //     newProject: false,
    //     urlPage: "scatterplot-graph-d3js",
    //     urlGit: "https://github.com/garciapereirajuan/scatterplot-graph-d3js",
    //     element: "AppScatterplotGraph"
    // },
    // {
    //     title:"Mapa coroplético con D3", 
    //     image: "imgChoroplethMap", 
    //     index: 3, 
    //     newProject: false,
    //     urlPage: "choropleth-map-d3js",
    //     urlGit: "https://github.com/garciapereirajuan/choropleth-map-d3js",
    //     element: "AppChoroplethMap"
    // },
    // {
    //     title:"Calculadora JavaScript", 
    //     image: "imgCalculadoraDeJavaScript", 
    //     index: 4, 
    //     newProject: false,
    //     urlPage: "calculadora-de-javascript",
    //     urlGit: "https://github.com/garciapereirajuan/calculadora-javascript",
    //     element: "AppCalculadoraJS"
    // },
    // {
    //     title:"Caja de Ritmos", 
    //     image: "imgCajaDeRitmos", 
    //     index: 5, 
    //     newProject: false,
    //     urlPage: "caja-de-ritmos",
    //     urlGit: "https://github.com/garciapereirajuan/caja-de-ritmos",
    //     element: "AppCajaDeRitmos"
    // },
    // {
    //     title:"Editor de Markdown", 
    //     image: "imgEditorMarkdown2", 
    //     index: 6, 
    //     newProject: false,
    //     urlPage: "editor-de-markdown",
    //     urlGit: "https://github.com/garciapereirajuan/editor-de-markdown",
    //     element: "AppEditorMarkdown"
    // },
    // {
    //     title:"Máquina de frases", 
    //     image: "imgMaquinaCitas2", 
    //     index: 7, 
    //     newProject: false,
    //     urlPage: "maquina-de-citas",
    //     urlGit: "https://github.com/garciapereirajuan/maquina-de-citas",
    //     element: "AppMaquinaCitas"
    // },
    // {
    //     title:"Página Tributo", 
    //     image: "imgPaginaTributo2", 
    //     index: 8, 
    //     newProject: false,
    //     urlPage: "pagina-tributo/indra-devi",
    //     urlGit: "https://github.com/garciapereirajuan/pagina-tributo-indra-devi",
    //     element: "AppPaginaTributo"
    // },
    // {
    //     title:"Documentación Técnica", 
    //     image: "imgDocumentacionTecnica", 
    //     index: 9, 
    //     newProject: false,
    //     urlPage: "documentacion/tecnica-css",
    //     urlGit: "https://github.com/garciapereirajuan/documentacion-tecnica-css",
    //     element: "AppDocumentacionTecnica"
    // },
    // {
    //     title:"Destino de Productos", 
    //     image: "imgDestinoProductos", 
    //     index: 10, 
    //     newProject: false,
    //     urlPage: "destino-de-productos/comiendo-sano",
    //     urlGit: "https://github.com/garciapereirajuan/destino-de-productos-comiendo-sano",
    //     element: "AppDestinoProductos"
    // }
]

export default dataBlog;